import { FilterDoc, Operators } from './types';

const FALLBACK_OPERATOR = Operators.AND;

export const EMPTY_FILTER_DOC: FilterDoc = {
	operator: FALLBACK_OPERATOR,
	model: [],
};
